
      import API from "!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/source-map-loader/dist/cjs.js!./style.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);


if (module.hot) {
  if (!content.locals || module.hot.invalidate) {
    var isEqualLocals = function isEqualLocals(a, b, isNamedExport) {
  if (!a && b || a && !b) {
    return false;
  }

  var p;

  for (p in a) {
    if (isNamedExport && p === "default") {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (a[p] !== b[p]) {
      return false;
    }
  }

  for (p in b) {
    if (isNamedExport && p === "default") {
      // eslint-disable-next-line no-continue
      continue;
    }

    if (!a[p]) {
      return false;
    }
  }

  return true;
};
    var isNamedExport = !content.locals;
    var oldLocals = isNamedExport ? namedExport : content.locals;

    module.hot.accept(
      "!!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/source-map-loader/dist/cjs.js!./style.css",
      function () {
        if (!isEqualLocals(oldLocals, isNamedExport ? namedExport : content.locals, isNamedExport)) {
                module.hot.invalidate();

                return;
              }

              oldLocals = isNamedExport ? namedExport : content.locals;

              update(content);
      }
    )
  }

  module.hot.dispose(function() {
    update();
  });
}


export * from "!!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/react-scripts/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../../../../../layers/paketo-buildpacks_npm-install/launch-modules/node_modules/source-map-loader/dist/cjs.js!./style.css";
       export default content && content.locals ? content.locals : undefined;
